import { resolveTimezone } from 'shared/lib/timezone';

const USER_KEY = 'platform_auth_user';

/**
 * Resolved timezone for non-React code (streaks, daily goals, pure utils).
 * Reads the preference persisted on the auth user in localStorage; falls back
 * through resolveTimezone (browser → Asia/Kolkata).
 */
export function getStoredUserTimezone(): string {
  try {
    if (typeof localStorage !== 'undefined') {
      const raw = localStorage.getItem(USER_KEY);
      if (raw) {
        const user = JSON.parse(raw) as { timezone?: string | null };
        return resolveTimezone(user?.timezone);
      }
    }
  } catch {
    /* ignore corrupt storage */
  }
  return resolveTimezone(null);
}
